import _defineProperty from "@babel/runtime/helpers/defineProperty";
/**
 * @module
 *
 * @description Constants used by WordPress utils
 */

/**
 * WordPress NW post types.
 *
 * Should match https://github.com/NerdWallet/wp/blob/977b8d5472459d8f40b415fa88c55ab7e7046b3c/src/wp-content/mu-plugins/nerdwallet-config/config/post-types.json#L3859-L3862
 *
 * @type {Object}
 */
export var POST_TYPES = {
  ARTICLE: 'nw_article',
  ROUNDUP: 'nw_roundup',
  REVIEW: 'nw_review'
};

/**
 * Labeling for each of the WordPress NW post types.
 *
 * @type {Object}
 */
export var POST_TYPE_LABELS = _defineProperty(_defineProperty(_defineProperty({}, POST_TYPES.ARTICLE, 'Article'), POST_TYPES.REVIEW, 'Editorial Review'), POST_TYPES.ROUNDUP, 'Best of');

/**
 * Subset of initial WordPress post statuses.
 * @note To be potentially augmented with custom NW post_statuses
 *
 * https://core.trac.wordpress.org/browser/tags/5.1.1/src/wp-includes/post.php#L0
 *
 * @type {Object}
 */
export var POST_STATUSES = {
  DRAFT: 'draft',
  FUTURE: 'future',
  PENDING: 'pending',
  PUBLISHED: 'publish',
  TRASHED: 'trash'
};

/**
 * Roundup drivers for summary list. (Used for roundup summary list driver configuration)
 *
 * @note not yet configurable for backwards compat: see https://nerdwallet.atlassian.net/browse/SHOP-4710
 *
 * @type {Object}
 */
export var ROUNDUP_SUMMARY_LIST_DRIVERS = {
  CATEGORY: 'category'
};

/**
 * Banking quick fact drivers. (Used for roundup summary list driver configuration)
 *
 * https://github.com/NerdWallet/wp/blob/520a6a910887945f83fc9cff6129977f0ba2b971/src/wp-content/mu-plugins/nerdwallet-config/config/post-types.json#L1385-L1389
 *
 * @type {Object}
 */
export var BANKING_QUICK_FACT_DRIVERS = {
  MINIMUM_BALANCE: 'minimum_balance',
  OUT_OF_NETWORK_ATM_FEE: 'out_of_network_atm_fee',
  MONTHLY_FEE: 'monthly_fee',
  BONUS: 'bonus',
  APY: 'apy'
};

/**
 * WP string constants for show or hide flags
 *
 * @type {Object}
 */
export var DISPLAY_FLAGS = {
  SHOW: 'show',
  NONE: 'none'
};

/**
 * Keys nested under the `_embedded` augmented WordPress entity.
 *
 * @type {Object}
 */
export var EMBEDDED_OBJECT_TYPES = {
  AUTHOR: 'author',
  BLOCK: 'nw:nw_block',
  BLOCK_GROUP: 'nw:nw_block_group',
  FEATURED_MEDIA: 'wp:featuredmedia',
  REVIEWER: 'nw:nw_reviewer',
  TERM: 'wp:term'
};

/**
 * Date formats for title.
 *
 * Should match https://github.com/NerdWallet/wp/blob/d5c20cee778899bf787437a527b5ae54ad91e356/src/wp-content/mu-plugins/nerdwallet-config/config/post-types.json#L1254-L1255
 *
 * @type {Object}
 */
export var TITLE_DATE_FORMATS = {
  MONTH_AND_YEAR: 'month_and_year'
};